import {EmptyProps} from "../../common/empty/Empty.props";
import {ListColumnType, ListHeader} from "../../common/list/List.props";

export const HEADERS: ListHeader[] = [
    {
        type: ListColumnType.CHECK_BOX,
        name: "",
        key: ""
    },
    {
        type: ListColumnType.LONG_TEXT,
        name: "강의명",
        key: "title"
    },
    {
        type: ListColumnType.NORMAL,
        name: "모집 마감일",
        key: "expiredDate"
    },
    {
        type: ListColumnType.NORMAL,
        name: "신청 인원",
        key: ["count", "capacity"],
        convertToString: (count: number, capacity: number): string => {
            return `${count}명 / ${capacity}명`;
        }
    },
    {
        type: ListColumnType.STATUS,
        name: "상태",
        key: "expiredDate",
        convertToString: (expiredDate: string): string => {
            const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));

            return new Date(expiredDate) < yesterday
                ? "마감"
                : "모집중";
        },
        getCellStyle: (expiredDate: string): {} => {
            const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));

            return {
                color: new Date(expiredDate) < yesterday? "" : "var(--primary)"
            };
        }
    },
    {
        type: ListColumnType.NORMAL,
        name: "인당 강의료",
        key: "price"
    }
];

export const EMPTY_PROPS = (handleButtonClick: () => void): EmptyProps => {
    return {
        messageText: "강의 정보가 없습니다.",
        buttonText: "강의 추가 개설",
        handleButtonClick: handleButtonClick
    };
}